var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutPlanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6806_26693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2834 20.17C23.0675 20.17 24.6979 17.7986 23.3374 15.5442C22.3415 13.8882 21.5723 12.7881 20.8376 11.339C20.7463 11.1598 20.5827 10.9185 20.2834 10.9185C19.9826 10.9185 19.8186 11.1598 19.7291 11.339C18.9929 12.7881 18.2047 13.873 17.2392 15.5442C16.0423 17.6157 17.4931 20.17 20.2834 20.17H20.2834Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0122 16.8101C22.0122 17.6276 21.311 18.2903 20.4458 18.2903",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6061 19.0952C35.3014 19.5398 35.3014 20.6805 34.6061 21.1251L21.3923 29.5742C20.6969 30.0188 19.5706 30.0188 18.8753 29.5742L5.66152 21.1251C4.9662 20.6805 4.9662 19.5398 5.66151 19.0952",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6061 23.7202C35.3014 24.1648 35.3014 25.3055 34.6061 25.7501L21.3923 34.1992C20.6969 34.6438 19.5706 34.6438 18.8753 34.1992L5.66152 25.7501C4.9662 25.3055 4.9662 24.1648 5.66151 23.7202",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8753 24.9478L5.66151 16.4986C4.96622 16.054 4.9662 15.3339 5.66151 14.8893L18.8753 6.44015C19.5706 5.99555 20.6969 5.99556 21.3922 6.44015L34.6061 14.8893C35.3014 15.3339 35.3014 16.054 34.6061 16.4986L21.3922 24.9478C20.6969 25.3924 19.5675 25.3903 18.8753 24.9478V24.9478Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6806_26693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.8164,
    height: 39.8901,
    transform: "translate(4 0.367188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutPlanIcon);
export default __webpack_public_path__ + "static/media/checkout_plan_icon.2a7d42c013c5356154e6d210c5a136a5.svg";
export { ForwardRef as ReactComponent };